import React from "react";
import { Icons } from "contents/icons";
import { Icon } from "components/icon/Icon";
import { StyledDialogBody } from "./style";
import { useDialogOverlayContext } from "components/dialog/controller/DialogOverlay";

interface DialogBodyProps {
  icon?: keyof typeof Icons;
  children: React.ReactNode;
}

export const DialogBody = ({ icon, children }: DialogBodyProps) => {
  const { $size, $state } = useDialogOverlayContext();
  return (
    <StyledDialogBody
      $size={$size}
      $state={$state}
      $flexFlow={icon ? "row nowrap" : "column nowrap"}
    >
      {icon && (
        <Icon
          className="status-icon"
          icon={icon}
          size={$size === "large" ? 24 : 20}
          stroke={
            $state === "info"
              ? "--text-gray-strong"
              : $state === "success"
                ? "--pri-blue-5"
                : $state === "warning"
                  ? "--sec-orange-5"
                  : "--sys-red-1"
          }
        />
      )}
      {children}
    </StyledDialogBody>
  );
};
